module.exports = "/assets/images/mind_blown.png";